import './event-description.scss';
import {useParams} from "react-router-dom";
import React, {useState} from "react";
import { AWS_S3_BUCKET } from '../../../../global_vars';
import EventRegistrationForm from "../event-registration-form/event-registration-form";

function EventDescription() {

    const { event_code } = useParams();

    const [showEventRegistrationModal, setShowEventRegistrationModal] = useState(false);

    const event_poster = `${AWS_S3_BUCKET}/property_show_event_poster.jpg`;
    const event_poster_landscape = `${AWS_S3_BUCKET}/property_show_event_poster_landscape.jpg`;
    const event_poster_property_show = `${AWS_S3_BUCKET}/property_show_${event_code}.jpg`

    const postEventRegistration = () => {
        setShowEventRegistrationModal(true);
    }

    return (
        <div className="event" style={{paddingTop: "80px"}}>
            <img src={event_poster_property_show} className="event-poster" onClick={postEventRegistration} />
            <EventRegistrationForm isOpen={showEventRegistrationModal} onClose={() => setShowEventRegistrationModal(false)} eventCode={event_code ?? "NJMAY2025"} />
        </div>
    );
}

export default EventDescription;